import { useTranslate } from '../../hooks'
import {
  formatNumberWithCommas,
  removeCommasFromNumber,
} from '@repo/tools/src/convert'
import { Col, Input, InputNumericStepper } from '@repo/ui/components'
import { useIsDesktop } from '@repo/ui/hooks'
import type { AdvancedTradeBoxTotalInputProps } from './advanced-trade-box.types'

export const AdvancedTradeBoxTotalInput = ({
  value,
  onChange,
  label,
}: AdvancedTradeBoxTotalInputProps) => {
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()

  return (
    <Col className='gap-xs'>
      {label && isDesktop && (
        <span className='font-bold text-xs text-neutral-surface-80'>
          {label}
        </span>
      )}
      {isDesktop ? (
        <Input
          type='text'
          value={formatNumberWithCommas(value)}
          onChange={(e) => {
            const cleanValue = removeCommasFromNumber(e.target.value)
            onChange(Number(cleanValue) || 0)
          }}
          min={0}
          inputSize='md'
          endLabel={t('currency_toman')}
          className='flex-1'
        />
      ) : (
        <InputNumericStepper
          value={formatNumberWithCommas(value)}
          onChange={(e) => {
            const cleanValue = removeCommasFromNumber(e.target.value)
            onChange(Number(cleanValue) || 0)
          }}
          min={0}
          step={50000}
          inputSize='sm'
          className='w-full ltr'
          placeholder={t('order_total_toman')}
        />
      )}
    </Col>
  )
}
